module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Clothes/Brassiere-e4e2b1ced29100e2b622b289b5776d81.svg";